import { useTranslation } from "react-i18next";
import FlintDialog from "@components/controls/dialogs/FlintDialog";
import FlintButton from "@components/controls/FlintButton";
import FlintTextBox from "@components/controls/FlintTextBox";
import { SapCodeEditPopupProps, useSapCodeEditPopup } from "./useSapCodeEditPopup";

export type { SapCodeEditPopupProps };

export default function SapCodeEditPopup(props: SapCodeEditPopupProps) {
    const { t } = useTranslation();
    const { state, handlers } = useSapCodeEditPopup(props);

    if (!props.isOpen) return null;

    const actionButtons = (
        <>
            <FlintButton themeColor={"secondary"} type="button" onClick={props.onClose}>
                {t("SAP_CODE_Cancel")}
            </FlintButton>
            <FlintButton themeColor={"primary"} type="button" onClick={handlers.handleSave} disabled={!state.isValid}>
                {t("SAP_CODE_Save")}
            </FlintButton>
        </>
    );

    return (
        <FlintDialog
            title={t("SAP_CODE_PopupTitle")}
            onClose={props.onClose}
            dialogActionButtons={actionButtons}
            width={320}
        >
            <FlintTextBox
                value={state.localValue}
                onChange={e => handlers.handleChange(e.value)}
                maxLength={8}
                autoFocus
            />
        </FlintDialog>
    );
}
